import { Uuid, uuidSerializer } from "@legacy-megarax/common";
import { MSerializers } from "@legacy-megarax/serializers";

import { Gtin, gtinSerializer } from "../common";

export interface TradeItemDto {
  gtin: Gtin;
  itemName: string;
}

export const tradeItemDtoSerializer = MSerializers.object<TradeItemDto>({
  gtin: gtinSerializer,
  itemName: MSerializers.string,
});
